import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {updateTimes} from 'search-request/search-request-actions';
import AirportDateTimePickers from 'common/airport/AirportDateTimePickers';

class SearchAirportControls extends Component {
    static propTypes = {
        starts: PropTypes.string,
        ends: PropTypes.string,
        updateSearchTimes: PropTypes.func.isRequired,
        onSubmit: PropTypes.func
    };

    _onSearchClick = ({starts, ends}) => {
        const {
            updateSearchTimes,
            onSubmit
        } = this.props;

        updateSearchTimes({
            starts,
            ends
        });

        if (onSubmit) {
            onSubmit();
        }
    }

    render() {
        const {
            starts,
            ends
        } = this.props;

        return (
            <div className="SearchAirportControls">
                <AirportDateTimePickers
                    starts={starts}
                    ends={ends}
                    onSearchClick={this._onSearchClick}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {
        searchRequest: {
            starts,
            ends
        }
    } = state;

    return {
        starts,
        ends
    };
};

const mapDispatchToProps = {
    updateSearchTimes: updateTimes
};

export default connect(mapStateToProps, mapDispatchToProps)(SearchAirportControls);
